module.exports = __webpack_public_path__ + "static/img/icon_dsf.694e85ee.svg";